"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMapValuesToDecimal = deepMapValuesToDecimal;
exports.deepMapValuesToFirst = exports.deepMapValues = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _decimal = _interopRequireDefault(require("decimal.js"));

var _deepObjectMap = _interopRequireDefault(require("./deepObjectMap"));

var _lodash = _interopRequireDefault(require("lodash.mapvalues"));

var deepMapValues = function deepMapValues(callback) {
  return (0, _deepObjectMap["default"])(function (object) {
    return (0, _lodash["default"])(object, callback);
  });
};

exports.deepMapValues = deepMapValues;

function firstOrValue(val) {
  return Array.isArray(val) ? val[0] : val;
}

var deepMapValuesToFirst = deepMapValues(firstOrValue);
exports.deepMapValuesToFirst = deepMapValuesToFirst;

function isId(key) {
  return key.toLowerCase() === 'id' || key.match(/Id$/);
}

function deepMapValuesToDecimal(opts) {
  var options = (0, _extends2["default"])({
    excludeIds: true
  }, opts);
  return deepMapValues(function (value, key) {
    var result = value;

    if (typeof value === 'number' && (!options.excludeIds || !isId(key))) {
      result = new _decimal["default"](value);
    }

    return result;
  });
}